// extracted by mini-css-extract-plugin
export default {"categoryMenu":"CategoryMenu_categoryMenu__xAE+u"};